// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_hp-3";
export var flatBottomCorners = "_hp-5";
export var productImage = "_hp-0";
export var quantityContainer = "_hp-2";
export var quantityHeader = "_hp-6";
export var tooltip = "_hp-1";
export var wrapAndEllipsesOverflow = "_hp-4";